export const dayAvailabilityList_style = {};
